// extracted by mini-css-extract-plugin
export default {"dividerComponent":"Divider_dividerComponent__Sq2qN"};